export default __webpack_public_path__ + "static/Mont-ExtraLight-af7415d3c0de7f108ae19522b0f2450b.otf";